module.exports = __webpack_public_path__ + "img/icon-settings-white.803d482f.svg";